<template>
  <div class="chenggong">
    <img src="@/assets/image/success.png" alt="" srcset="" />
    <div class="title">发起成功</div>
    <div class="desc">请查看短信根据提示进行操作</div>
    <el-button type="primary" class="button" @click="toHome">返回首页</el-button>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    toHome(){
      this.$router.push({path:'/'})
      this.$store.dispatch('hetongqianshu/setStep',1)
    }
  },
};
</script>

<style scoped lang="scss">
.chenggong {
  width: 100%;
  height: 258px;
  border-radius: 4px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 44px;
  padding-bottom: 56px;
  img {
    width: 48px;
    height: 48px;
  }
  .title {
    font-family: "Noto Sans SC";
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;

    font-variation-settings: "opsz" auto;
    color: #1d2129;

    z-index: 0;
    margin-top: 16px;
  }
  .desc {
    font-family: "Noto Sans SC";
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #86909c;

  }
  .button{
    margin-top: 16px;
    @include buttonStyle;
  }
}
</style>
